<template>
  <div :style="{backgroundColor: menu.titleItemBackgroundColor || 'inherit',}" >
    <div class="mt-1 mb-1" style="padding: 10px;">
      <div class="row align-items-center border-bottom mx-0 pb-1">
        <!-- Left: item name -->
        <div class="col-7 p-0">
          <span
            class="item-text"
            :style="{
              fontFamily: menu.productFontFamily || 'inherit',
              color: menu.productFontColor || 'inherit',
              fontSize: menu.productFontSize || 'inherit',
              textDecoration: menu.productTextDecoration || 'inherit',
              fontStyle: menu.productFontStyle || 'inherit',
              fontWeight: menu.productFontWeight || 'inherit'
            }"
          >
            {{ item.name }}
          </span>
        </div>

        <!-- Right: price, wishlist, add -->
        <div class="col-5 p-0 text-end d-flex align-items-center justify-content-end">
          <span
            class="item-price d-flex align-items-center"
            :style="{
              fontFamily: menu.productFontFamily || 'inherit',
              fontWeight: menu.productFontWeight || 'inherit',
              color: menu.productFontColor || 'inherit',
            }"
          >
            {{ item.price }}

            <img
              v-if="isInWishlist(item.id)"
              src="@/assets/icons/heart-full-red.svg"
              height="20"
              class="ml-2"
              alt="wishlist full"
              @click.stop="$emit('removeFromWishlist', item.id)"
            />

            <img
              v-else
              src="@/assets/icons/heart-red.svg"
              height="20"
              class="ml-2"
              alt="wishlist empty"
              @click.stop="$emit('addToWishlist', item.id, false, sectionId)"
            />

            <div
              v-if="orderIsActif && !item.isNotAvailableOnline"
              class="add-to-cart-icon ml-1 d-flex align-items-center justify-content-center"
              @click.stop="$emit('toggleModalDescription', item, sectionId)"
            >
              <img src="@/assets/icons/add-p.svg" height="17" width="17" />
            </div>
          </span>
        </div>
      </div>

      <!-- Description -->
      <div
        v-if="item.description"
        class="item-description"
        style="letter-spacing: 0.8px;"
        v-html="formattedDescription"
        :style="{
          fontFamily: menu.productFontFamily || 'inherit',
          fontStyle: menu.productFontStyle || 'inherit',
          color: menu.itemDescriptionColor || 'inherit',
        }"
      ></div>
    </div>
  </div>

</template>

<script>
export default {
  name: "MenuItemRow",
  props: {
    item: Object,
    index: Number,
    secIndex: Number,
    sectionId: [String, Number],
    menu: Object,
    orderIsActif: Boolean,
    isInWishlist: Function,
  },
  computed: {
    formattedDescription() {
      return this.item.description
        ? this.item.description.replace(/\n/g, "<br/>")
        : "-";
    },
  },
};
</script>

<style scoped>
.add-to-cart-icon {
  background-color: #c8e2cda9;
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  width: 22px;
  height: 22px;
}

.item-text {
  line-height: 1.5;
  cursor: default;
  word-break: break-word;
}

.item-price {
  color: #12151c;
  font-size: 13px;
  cursor: default;
  text-align: right;
  line-height: 1.5;
  white-space: nowrap;
}

.item-description {
  margin-top: 10px;
  margin-bottom: 10px;
  min-width: 100%;
  font-size: 13px;
  cursor: default;
  line-height: 1.5;
  text-transform: uppercase;
}
</style>
